const marketingUrl = () => import('@/views/main/marketing/index.vue')
export default {
  path: '/main/marketing/list',
  name: 'marketingList',
  component: marketingUrl,
  children: []
}
